// Rake: pulls loose leaves within 1.2 m toward the operator's feet. Works in
// garden beds and along fences, where the blower struggles. Feature P6: with
// debris rules it is the only tool that takes a leaf out of a bed.

import type { Ctx } from '../ctx';

export const RAKE_REACH = 1.2;
export const RAKE_PULL = 0.8;

export function stepRake(ctx: Ctx): void {
  const sg = Math.sqrt(ctx.gs);
  const reach = RAKE_REACH * sg;
  const pull = RAKE_PULL * sg;
  const op = ctx.op;
  const L = ctx.leaves;
  for (let k = 0; k < L.count; k++) {
    if (L.state[k] !== 0) continue;
    const dx = op.x - L.x[k];
    const dy = op.y - L.y[k];
    if (dx > reach || dx < -reach || dy > reach || dy < -reach) continue;
    const d = Math.hypot(dx, dy);
    if (d > reach || d < 0.3) continue;
    L.vx[k] = (dx / d) * pull;
    L.vy[k] = (dy / d) * pull;
    if (ctx.debris) ctx.leafRaked[k] = 1;
  }
}
